import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.auth || initialState;

export const selectInit = createSelector([selectDomain], authState => authState.init);
